<template>
  <div class="block-split__header mx-auto">
    <div class="u-mb-1 mt-lg-5 mt-xl-5 mt-md-5 mt-sm-2 mt-2 mx-auto div-header-text">
      <h1 class="mt-4">{{ translate.credits.title }}</h1>
    </div>
    <div class="card mx-auto">
      <p v-html="translate.credits.subBenefits" class="u-mb-1 u-mb-md-1 div-header-text2"></p>
      <ul class="bulleted-list">
        <li v-for="(list, index) in translate.credits.listBenefits" :key="index">
          <p v-html="list"></p>
        </li>
      </ul>
      <div
        class="d-flex flex-column justify-content-center mt-3 mx-4 p-4"
        style="border-top: 1px solid #9d9d9d60"
      >
        <p class="body-price">A partir de:</p>
        <p class="mt-2 mx-auto value">
          <span>{{ locale == 'pt-br' ? 'R$7,30' : 'U$3.54' }}</span
          >/download
        </p>
      </div>
      <div class="d-w-btn mx-auto mb-1">
        <button @click="redirect('AssineOptionsPage')">
          {{ translate.buttonCredits }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateAssine from 'tradutors/assine'
  import router from 'router'
  import { isMobile } from 'views/shared/utils/mobile'

  export default defineComponent({
    name: 'BoxTitleAssinantes',
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return translateAssine.portugues
        } else {
          return translateAssine.ingles
        }
      }
    },
    data() {
      return {
        isMobile: isMobile()
      }
    },
    methods: {
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          },
          query: {
            acionador: this.$route.name,
            redirectCredits: true
          }
        })
      },
      goToSubscribe() {
        window.scrollBy({
          top: isMobile() ? 250 : 725,
          left: 0,
          behavior: 'smooth'
        })
      },
      goToSubscribe2() {
        window.scrollBy({
          top: 800,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  })
</script>

<style scoped lang="css">
  .block-split__header {
    padding-left: 10px;
  }
  .block-split__header h1 {
    font-family: 'Roboto-Regular';
    color: #000000;
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0;
    text-align: center;
  }

  .block-split__header img {
    width: 17px;
    height: 18px;
    margin-right: 10px;
    object-fit: cover;
  }

  .block-split__header li {
    list-style: disc;
    margin-bottom: 2px;
  }

  .block-split__header ul {
    padding-inline: 20px;
    min-height: 270px;
  }

  .block-split__header li p {
    color: #000000;
    font-family: 'Roboto-Regular';
    font-size: 11px;
    letter-spacing: 0;
    line-height: 16px;
  }

  .value span {
    font-family: 'Roboto-Regular';
    color: #000000;
    font-size: 25px;
    line-height: 36px;
    font-weight: 700;
  }

  .value {
    font-family: 'Roboto-Regular';
    font-size: 20px;
    line-height: 31px;
    font-weight: 500;
  }

  .body-price {
    font-size: 10px;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 500;
  }

  .card {
    padding: 20px;
    background-color: #ffffff;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    border: 1px solid #0c0c0c;
  }

  .card hr {
    margin: 0;
    padding: 0;
    border: none;
    margin-top: 20px;
    border-bottom: solid 1px #ddd;
    margin-bottom: 20px;
  }

  .holder p {
    height: 19px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    margin-right: 5px;
  }

  .holder a {
    font-weight: 600;
    color: #b20000;
    cursor: pointer;
  }

  .holder a:hover {
    text-decoration: underline;
    background-color: unset;
  }

  .u-mb-1 {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    text-align: center;
  }

  .d-w-btn {
    margin-top: 5px;
    background: #6ca727;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 21.6px;
    font-weight: 700;
    letter-spacing: 0;
    width: 220px;
    height: 42px;
    padding: 2px;
  }

  .d-w-btn button {
    color: #fff;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {

    .div-header-text {
      z-index: 99;
      text-align: center !important;
      margin-left: -10px;
      width: 100%;
    }

    .block-split__header h1 {
      font-family: 'Roboto-Regular';
      font-size: 34px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 41px;
    }

    .button--o {
      display: inline-flex;
    }
  }
</style>
